<template>
  <form
    ref="form"
    class="standard-form"
    action="/my/account/subscription/resume"
    method="post"
    novalidate
    @submit.prevent="handleSubmit"
  >
    <div class="form-actions">
      <div class="form-action">
        <csrf-input />
        <submit-button
          type="submit"
          class="btn -main"
          :submitting="processing"
          label="Resume FB Plus"
          :submitting-label="submittingLabel"
          @submit-action="openModal"
        />
      </div>
    </div>
  </form>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState, mapActions } from 'pinia'
import { useModalsStore } from '@/stores/modals'
import SubmitButton from '../buttons/submit-button.vue'
import CsrfInput from '../forms/csrf-input.vue'

export default defineComponent({
  name: 'SubscriptionResume',
  components: {
    SubmitButton,
    CsrfInput,
  },
  props: {},
  data() {
    return {
      processing: false,
    }
  },
  computed: {
    ...mapState(useModalsStore, ['simpleModal']),

    submittingLabel() {
      return 'Processing...'
    },

    modalId() {
      return 'subscription-resume-modal'
    },
  },
  watch: {
    'simpleModal.action'(newAction, prevAction) {
      if (
        this.simpleModal.id === this.modalId &&
        newAction !== prevAction &&
        newAction === 'confirm' &&
        !this.processing
      ) {
        this.handleSubmit()
      }
    },
  },
  methods: {
    ...mapActions(useModalsStore, ['openSimpleModal']),

    openModal() {
      this.openSimpleModal({
        type: 'CONFIRM',
        id: this.modalId,
        props: {
          heading: 'Resume FB Plus',
          subheading: 'Are you sure you want to resume your FB Plus membership?',
          buttonText: 'Yes',
          cancelText: 'No',
        },
      })
    },

    handleSubmit() {
      if (this.$refs.form instanceof HTMLFormElement) {
        this.processing = true
        this.$refs.form.submit()
      }
    },
  },
})
</script>
